var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 655,
    height: 853,
    viewBox: "0 0 655 853",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    filter: "url(#filter0_bif_5059_78464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.222 485.867C408.222 463.873 390.393 446.044 368.4 446.044H268.844C246.851 446.044 229.022 463.873 229.022 485.867V625.244C229.022 647.238 211.193 665.067 189.2 665.067H49.8222C27.829 665.067 10 682.896 10 704.889L10 804.444C10 826.438 27.829 844.267 49.8222 844.267H248.933C336.906 844.267 408.222 772.951 408.222 684.978V485.867Z",
    fill: "white",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.4 448.044C389.289 448.044 406.222 464.978 406.222 485.867V684.978C406.222 771.846 335.802 842.267 248.933 842.267H49.8222C28.9336 842.267 12 825.333 12 804.444L12 704.889C12 684 28.9336 667.067 49.8222 667.067H189.2C212.298 667.067 231.022 648.342 231.022 625.244V485.867C231.022 464.978 247.956 448.044 268.844 448.044H368.4Z",
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    filter: "url(#filter1_bif_5059_78464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.289 8C81.3161 8 10 79.3161 10 167.289L10 246.933C10 334.906 81.3161 406.222 169.289 406.222H368.4C390.393 406.222 408.222 388.393 408.222 366.4V266.844C408.222 244.851 390.393 227.022 368.4 227.022L229.022 227.022C218.026 227.022 209.111 218.108 209.111 207.111C209.111 196.115 218.026 187.2 229.022 187.2L368.4 187.2C390.393 187.2 408.222 169.371 408.222 147.378V47.8222C408.222 25.829 390.393 8 368.4 8L169.289 8Z",
    fill: "white",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 167.289C12 80.4206 82.4206 10 169.289 10L368.4 10C389.289 10 406.222 26.9336 406.222 47.8222V147.378C406.222 168.266 389.289 185.2 368.4 185.2L229.022 185.2C216.921 185.2 207.111 195.01 207.111 207.111C207.111 219.212 216.921 229.022 229.022 229.022L368.4 229.022C389.289 229.022 406.222 245.956 406.222 266.844V366.4C406.222 387.289 389.289 404.222 368.4 404.222H169.289C82.4206 404.222 12 333.802 12 246.933L12 167.289Z",
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    filter: "url(#filter2_bif_5059_78464)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M726.8 8L487.867 8C465.873 8 448.044 25.829 448.044 47.8222V366.4C448.044 388.393 465.873 406.222 487.867 406.222H726.8C814.773 406.222 886.089 334.906 886.089 246.933V167.289C886.089 79.3161 814.773 8 726.8 8ZM686.978 187.2C697.974 187.2 706.889 196.115 706.889 207.111C706.889 218.108 697.974 227.022 686.978 227.022H647.156C636.159 227.022 627.244 218.108 627.244 207.111C627.244 196.115 636.159 187.2 647.156 187.2H686.978Z",
    fill: "white",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M726.8 446.044H487.867C465.873 446.044 448.044 463.874 448.044 485.867L448.044 804.444C448.044 826.438 465.873 844.267 487.867 844.267H726.8C814.773 844.267 886.089 772.951 886.089 684.978V605.333C886.089 517.361 814.773 446.044 726.8 446.044ZM686.978 625.244C697.974 625.244 706.889 634.159 706.889 645.156C706.889 656.152 697.974 665.067 686.978 665.067H647.156C636.159 665.067 627.244 656.152 627.244 645.156C627.244 634.159 636.159 625.244 647.156 625.244H686.978Z",
    fill: "white",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.867 10L726.8 10C813.668 10 884.089 80.4206 884.089 167.289V246.933C884.089 333.802 813.668 404.222 726.8 404.222H487.867C466.978 404.222 450.044 387.289 450.044 366.4V47.8222C450.044 26.9336 466.978 10 487.867 10ZM708.889 207.111C708.889 195.01 699.079 185.2 686.978 185.2H647.156C635.054 185.2 625.244 195.01 625.244 207.111C625.244 219.212 635.054 229.022 647.156 229.022H686.978C699.079 229.022 708.889 219.212 708.889 207.111ZM487.867 448.044H726.8C813.668 448.044 884.089 518.465 884.089 605.333V684.978C884.089 771.846 813.668 842.267 726.8 842.267H487.867C466.978 842.267 450.044 825.333 450.044 804.444L450.044 485.867C450.044 464.978 466.978 448.044 487.867 448.044ZM708.889 645.156C708.889 633.054 699.079 623.244 686.978 623.244H647.156C635.054 623.244 625.244 633.054 625.244 645.156C625.244 657.257 635.054 667.067 647.156 667.067H686.978C699.079 667.067 708.889 657.257 708.889 645.156Z",
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bif_5059_78464",
    x: 2,
    y: 438.044,
    width: 414.222,
    height: 414.222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5059_78464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5059_78464",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.313726 0 0 0 0 0.682353 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5059_78464"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect3_foregroundBlur_5059_78464"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bif_5059_78464",
    x: 2,
    y: 0,
    width: 414.222,
    height: 414.222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5059_78464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5059_78464",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.313726 0 0 0 0 0.682353 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5059_78464"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect3_foregroundBlur_5059_78464"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bif_5059_78464",
    x: 440.044,
    y: 0,
    width: 454.044,
    height: 852.267,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5059_78464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5059_78464",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.313726 0 0 0 0 0.682353 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5059_78464"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect3_foregroundBlur_5059_78464"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowLogo);
export default __webpack_public_path__ + "static/media/shadow-logo.65eeb5ef8f1b72a6c1d2752bd96a1ee9.svg";
export { ForwardRef as ReactComponent };